import { forwardRef, useRef, useState } from 'react';
import { NumericFormat } from 'react-number-format';
import { FormControl, FormLabel, formLabelClasses, TextField } from '@mui/material';

const NumberFormatCustom = forwardRef((props, ref) => {
    NumberFormatCustom.displayName = 'NumberFormat';

    const { onChange, ...rest } = props;

    const attrs = {
        decimalScale: 2,
        thousandSeparator: ',',
        fixedDecimalScale: true,
        ...rest
    };

    return <NumericFormat {...attrs} getInputRef={ref} onValueChange={e => onChange(e, rest.name)} autoComplete="off" prefix="$" />;
});
export default function Currency(props) {
    const [value, setValue] = useState(props.value ?? '');
    const ref = useRef();

    const handleChange = event => {
        setValue(event.floatValue);
        props.onChange(props.minName, event.floatValue);
        props.onChange(props.maxName, event.floatValue);
        props.onChange(props.name, event.floatValue);
    };

    return (
        <FormControl fullWidth>
            <FormLabel variant="list-filter">{props.label}</FormLabel>
            <TextField
                value={value}
                fullWidth
                sx={theme => ({
                    [`& .${formLabelClasses.root}`]: {
                        fontSize: theme.typography.pxToRem(12),
                        fontWeight: 400
                    }
                })}
                inputRef={ref}
                onChange={handleChange}
                placeholder="$0.00"
                InputProps={{
                    inputComponent: NumberFormatCustom,
                    sx: {
                        '& input': {
                            textAlign: 'end'
                        }
                    }
                }}
            />
        </FormControl>
    );
}
